import React from 'react';

const FullWidthImage = () => {
    return (
        <div className="w-full relative">
            {/* Subtle top fade to blend with about section */}
            {/*<div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-white to-transparent z-10" />*/}

            {/* The image with slight zoom on hover */}
            <div className="w-full overflow-hidden">
                <img
                    src="/images/website cover before footer.png"
                    alt="Frelish"
                    // className="w-full h-auto block transition-transform duration-700 hover:scale-105"
                />
            </div>

            {/* Subtle bottom fade to blend with footer */}
            {/*<div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10" />*/}
        </div>
        /*<div className="w-full px-4 md:px-8 lg:px-16">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                    src="/images/website cover before footer.png"
                    alt="Frelish"
                    className="w-full h-auto block"
                />

                {/!* Optional: Inner border effect *!/}
                <div className="absolute inset-0 border-8 border-white/20 rounded-2xl pointer-events-none" />
            </div>
        </div>*/

    );
};

export default FullWidthImage;